export enum MessagesError {
  UNEXPECTED_ERROR = 'An unexpected error has occurred. Refresh the page and try again.',
  INVALID_CREDENTIALS = 'The username or password is incorrect.',
  ERROR_OCCURRED = 'Sorry, an error occurred, please try again.',
  ACCOUNT_DELETED = 'This account has been deleted.',
  FORBIDDEN = 'You are not authorized to perform this action.',
}
